function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.07 10.52h5.015c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6H5.071c-.33 0-.6.27-.6.6 0 .33.27.6.6.6zM13.398 13.82H5.08c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h8.317c.33 0 .601-.27.601-.6 0-.33-.27-.6-.6-.6zM13.398 18.32H5.08c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h8.317c.33 0 .601-.27.601-.6 0-.33-.27-.6-.6-.6z",
  fill: "#657087"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.222 5.57L13.368.24a.607.607 0 00-.44-.2H2.877A2.788 2.788 0 00.097 2.82v18.37c0 1.54 1.251 2.78 2.783 2.78h12.71a2.788 2.788 0 002.783-2.78V5.97c0-.15-.05-.29-.15-.4zm-4.724-3.41l2.972 3.27h-2.752c-.06 0-.22-.16-.22-.48V2.16zm2.092 20.61H2.879c-.87 0-1.582-.71-1.582-1.58V2.82c0-.87.711-1.58 1.582-1.58h9.418v3.71c0 .94.62 1.68 1.421 1.68h3.463v14.56a1.6 1.6 0 01-1.591 1.58z",
  fill: "#657087"
});

function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "9d66709ca3ba2ad195c5d1931b1983ce.svg";
export { SvgDocument as ReactComponent };